import { AddEditFolderComponent } from "./../../../../../../apps/resource-portal/src/app/pages/project/agendas/add-edit-folder/add-edit-folder.component";
import { DialogService } from "libs/core/src/lib/services/dialog.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FolderService } from "apps/resource-portal/src/app/services/folder.service";
import { TreeviewConfig, TreeviewItem } from "ngx-treeview";
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { takeUntil, Subject } from "rxjs";
import { AlertDialogComponent } from "../alert-dialog/alert-dialog.component";
import { PrivilegeService } from "apps/resource-portal/src/app/services/privilege.service";

@Component({
  selector: "concourse-folder-treeview",
  templateUrl: "./folder-treeview.component.html",
  styleUrls: ["./folder-treeview.component.scss"],
})
export class FolderTreeviewComponent implements OnInit, OnChanges {
  items = [];
  @Input("selectedItem") selectedItem: TreeviewItem;
  @Input("projectId") projectId;
  @Input("type") type = 1;
  @Input() canEdit: boolean = false;
  @Output("onSelectFolder") onSelectFolder = new EventEmitter();
  @Input("hasCreateAccessName") hasCreateAccessName = "";
  @Input("hasEditAccessName") hasEditAccessName = "";
  @Input("hasDeleteAccessName") hasDeleteAccessName = "";
  $unsubscribe = new Subject<void>();
  config: TreeviewConfig = {
    hasDivider: true,
    hasFilter: true,
    hasAllCheckBox: false,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 500,
  };
  constructor(
    public _folderService: FolderService,
    public _modalService: NgbModal,
    public _dialogService: DialogService,
    private privilegeService: PrivilegeService
  ) {}

  ngOnInit(): void {
    if (this.projectId) {
      this.getAllFolders(this.projectId);
    }
  }

  ngOnChanges(): void {
    console.log(this.type);
    this.getAllFolders(this.projectId);
  }

  folderSelect(folder) {
    console.log(folder);
    // if (folder && !folder.children) {
    let selectedFolder = { value: folder.value.id, text: folder.text };
    this.onSelectFolder.emit(selectedFolder);
    // }
  }

  addEditNewFolder(folder: TreeviewItem, mode) {
    let selectedFolder = { value: folder?.value?.id, text: folder?.text };
    const modalRef = this._modalService.open(AddEditFolderComponent, {
      size: "md",
      backdrop: "static",
    });
    modalRef.componentInstance.projectId = this.projectId;
    modalRef.componentInstance.selectedFolder = selectedFolder;
    modalRef.componentInstance.mode = mode;
    modalRef.componentInstance.type = this.type;
    modalRef.result.then((data) => {
      if (data) {
        this._dialogService.showToast(data, "success");
        this.getAllFolders(this.projectId);
      }
    });
  }

  deleteFolder(folder: TreeviewItem) {
    const modalRef = this._modalService.open(AlertDialogComponent, {
      size: "md",
      backdrop: "static",
    });
    modalRef.componentInstance.title = `Delete Folder`;
    modalRef.componentInstance.message1 = `Are you sure you want to Delete ${folder.text} Folder?`;
    modalRef.componentInstance.yes_label = `Yes, Delete`;
    modalRef.componentInstance.no_label = "No, Cancel";
    modalRef.result.then((data) => {
      if (data == "success") {
        let selectedFolder = { value: folder.value.id, text: folder.text };
        this._folderService
          .deleteFolder(selectedFolder.value)
          .pipe(takeUntil(this.$unsubscribe))
          .subscribe((res) => {
            this.getAllFolders(this.projectId);
          });
      }
    });
  }

  getAllFolders(projectId: string) {
    this._folderService
      .getAllFoldersByProjectId(projectId, this.type)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((items) => {
        this.items = this.transformItem(items);
      });
  }

  transformItem(arr) {
    arr = arr.map((a) => {
      return new TreeviewItem({
        text: a.name,
        value: { id: a.id, count: a.documentcount },
        collapsed: a?.parent ? true : false,
        children: this.transformItem(a.children),
      });
    });
    return arr;
  }

  hasAccess(role: string): boolean {
    return this.privilegeService.userProjectAccess(role, this.projectId);
  }
}
